import fp from 'lodash/fp';
import { LOCATION_CHANGE } from 'react-router-redux';
import { handleActions } from 'redux-actions';
import { mapReducersFromConfigurations } from '../../helpers/reducer';
import { configurations } from './configurations';

const initialRequest = (request) => ({
  [request]: {
    isFetching: false,
    error: null
  }
});

export const initialState = {
  externalCpd: undefined,
  request: {
    ...initialRequest('add'),
    ...initialRequest('update'),
    ...initialRequest('get'),
    ...initialRequest('delete'),
  },
  error: null
};

const reducer = handleActions({
  ...mapReducersFromConfigurations('externalCpd')(configurations),
  [LOCATION_CHANGE]: fp.flow(
    fp.set('request.get.isFetching')(false),
    fp.set('externalCpd')(undefined),
    fp.set('error')(null)
  )
}, {
    ...initialState
  }
);

export default reducer;



// WEBPACK FOOTER //
// ./src/state/modules/external-cpd/reducers.js